import { PlaneList } from '~/modules/sites';
import dashboardWrapper from '~/wrappers/dashboard';
import { t } from '~/i18n';

export default dashboardWrapper(PlaneList, t('menu.dashboard.settingsSites'));
